import { render, staticRenderFns } from "./weightingsComponent.vue?vue&type=template&id=19bebe30"
import script from "./weightingsComponent.vue?vue&type=script&lang=js"
export * from "./weightingsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports